// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7f5d6c27","952":"51640f75"}[chunkId] + ".chunk.js";
};